function generateMerchantUrl(baseUrl, merchant, isEgiftsPage, isSearch) {
    if (merchant.name !== 'Visa' && merchant.name !== 'Mastercard') {
        let merchantUrl = baseUrl + merchant.relativeUrl
        merchantUrl =
            merchantUrl.substring(merchantUrl.length - 1) !== '/'
                ? merchantUrl + '/'
                : merchantUrl

        return merchantUrl
    }

    const urlPrefix = merchant.name === 'Visa' ? 'visa-' : 'mastercard-'

    let virtualUrl = ''
    if (Boolean(isEgiftsPage)) {
        virtualUrl = 'virtual'
    } else if (!isSearch) {
        virtualUrl = 'buildacard'
    }

    return `${baseUrl}/${urlPrefix}gift-cards/${virtualUrl}`
}

export default generateMerchantUrl
